import React from 'react';
import { FormControl } from 'react-bootstrap';

const IntegerInput = ({ value, onChange, label, isInvalid, placeholder, userRoles }) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      onChange(inputValue);
    }
  };

  return (
    <div className="mb-3">
      {label && <label className="mb-1">{label}</label>}
      <FormControl
        placeholder={placeholder || 'Número'}
        value={value || ''}
        onChange={handleInputChange}
        isInvalid={isInvalid}
        readOnly={userRoles}
        autoComplete='off'
      />
      {isInvalid && <div className="invalid-feedback">{label} é obrigatório.</div>}
    </div>
  );
};

export default IntegerInput;